import { DialogType } from '../../../@types';
import { WelcomeBonusFilterFormData } from '../../../schema';
import {
  WELCOME_BONUS_PRODUCT_TYPE_OPTIONS,
  WELCOME_BONUS_SCOPE_OPTIONS,
  WELCOME_BONUS_VALIDITY_PERIOD_OPTIONS,
} from '../../../constants';
import useFilterForm from '../../../hooks/useFilterForm';
import { AdditionalQueryParams } from '../../../hooks/usePagination';
import FilterDialogLayout from '../../layouts/FilterDialogLayout';
import FormNumberInput from '../../molecules/FormNumberInput';
import FormSelect from '../../molecules/FormSelect';

const DEFAULT_FORM_DATA: WelcomeBonusFilterFormData = {
  product: undefined,
  welcomeBonusScope: undefined,
  validityPeriod: undefined,
  timeframe: undefined,
};

type Props = DialogType & {
  changeQuery: (data: AdditionalQueryParams) => void;
};

const FilterWelcomeBonus = ({ closeModal, changeQuery }: Props) => {
  const { control, handleSubmit, handleResetFilter } = useFilterForm<WelcomeBonusFilterFormData>({
    defaultData: DEFAULT_FORM_DATA,
    changeQuery,
  });

  const handleClose = () => {
    closeModal?.();
  };

  return (
    <FilterDialogLayout label='welcome bonuses' onClose={handleClose} onSave={handleSubmit} onReset={handleResetFilter}>
      <FormSelect control={control} name='product' label='Product' options={WELCOME_BONUS_PRODUCT_TYPE_OPTIONS} />
      <FormSelect control={control} name='welcomeBonusScope' label='Scope' options={WELCOME_BONUS_SCOPE_OPTIONS} />
      <FormSelect
        control={control}
        name='validityPeriod'
        label='Validity period'
        options={WELCOME_BONUS_VALIDITY_PERIOD_OPTIONS}
      />
      <FormNumberInput control={control} name='timeframe' label='Timeframe (days)' allowDecimals={false} />
    </FilterDialogLayout>
  );
};

export default FilterWelcomeBonus;
